import styled from 'styled-components'
import theme from 'theme_'

export const Container = styled.ul<{ isOpen: boolean }>`
  height: ${(p) => (p.isOpen ? 'auto' : 0)};
  border-radius: ${theme.spacing.xs};
  background: ${theme.overlay.newDropdownBlack};
  backdrop-filter: ${theme.overlay.SBlur};
  transition: height 0.2s ease;
  overflow: hidden;
  margin-top: ${(p) => p.theme.spacing.xs};
  padding: 0;

  ${(p) =>
    p.isOpen &&
    `
    box-shadow: 0px 16px 32px rgba(19, 27, 77, 0.15);
  `}

  @media ${theme.devices.desktop} {
    width: 300px;
    margin: 0;
    position: absolute;
    top: calc(100% + 12px);
    right: 0;
  }
`

export const Option = styled.li<{ isSelected: boolean }>`
  list-style: none;
  padding: ${(p) =>
    `${p.theme.spacing.sm} 0 ${p.theme.spacing.sm} ${p.theme.spacing.sm} `};
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;

  label {
    cursor: pointer;
  }

  &:hover {
    background-color: ${theme.overlay.newMenuHover};
  }

  ${(p) => p.isSelected && `background-color: ${theme.overlay.newMenuHover}; `}
`
